import { format, isBefore, parseISO } from 'date-fns';
import { Icon } from '../Icon/Icon';
import { TimeElement } from '../TimeElement/TimeElement';
import sv from '../Util/customDateFnsSwedish';
import { type TAPlan } from './TAPlan.types';
import { getTAPlanIcon } from './TAPlanUtils';

export interface ITAPlanListProps {
    items: TAPlan[];
}

function formatTAPlanDateRange(validFrom: string, validTo?: string): JSX.Element {
    const from = parseISO(validFrom);
    const to = validTo ? parseISO(validTo) : null;

    if (to && isBefore(to, new Date())) {
        return (
            <>
                Gällde till:{' '}
                <TimeElement date={to} dateTimeFormat="HH.mm">
                    {format(to, 'P', { locale: sv })}
                </TimeElement>
            </>
        );
    } else {
        return (
            <>
                Gäller från:{' '}
                <TimeElement date={from} dateTimeFormat="HH.mm">
                    {format(from, 'P', { locale: sv })}
                </TimeElement>
            </>
        );
    }
}

export const TAPlanList = ({ items }: ITAPlanListProps) => {
    return (
        <div className="linkable-item-list">
            {items.map((item, index) => (
                <div key={item.id} className="linkable-item-list__item">
                    {index > 0 && <hr />}
                    <a href={item.detailsPath}>
                        <div className="d-flex w-100 py-3 px-3">
                            <div className="align-self-center me-3">
                                <Icon symbol={getTAPlanIcon(item.status)} className="linkable-item-list__item-icon" />
                            </div>

                            <div>
                                <div className="mb-1 fw-bold">{item.locationDescription}</div>
                                <div>
                                    <span className="icon-clock" />
                                    {formatTAPlanDateRange(item.validFrom, item.validTo)}
                                </div>
                            </div>
                        </div>
                    </a>
                </div>
            ))}
        </div>
    );
};
